import * as React from 'react';
import { Props as ModalProps } from '../../../../Modal';
import { Baggage } from '../../../../BaggageService/types';
import { PassengerLabels } from '../../../../Checkout/types';
import { SelectedUpgrade } from '../../types';
import { useTranslation } from 'react-i18next';
import UpgradeBaggageDialog from '../../../UpgradeBaggageDialog/components/UpgradeBaggageDialog';
import { Passenger, Segment } from '../../../types';
import { ServiceMeta } from '../../../../Checkout/store/selectedServices/actions';

interface Props {
	open: boolean;
	onClose: ModalProps['onClose'];
	passengers: Passenger[];
	passengerLabels: PassengerLabels;
	segments: Segment[];
	upgradeBaggage: Baggage[];
	disabled: boolean;
	selectedServices: SelectedUpgrade[];
	dynamicBaggagePricing?: boolean;
	isLoading?: boolean;
	className?: string;
	analyticsMeta?: ServiceMeta;
}

const UpgradeModal: React.FC<Props> = props => {
	const { t } = useTranslation('IncludedBaggage');

	return (
		<UpgradeBaggageDialog
			className={props.className}
			open={props.open}
			onClose={props.onClose}
			passengers={props.passengers}
			passengerLabels={props.passengerLabels}
			segments={props.segments}
			upgradeBaggage={props.upgradeBaggage}
			disabled={props.disabled}
			selectedServices={props.selectedServices}
			headerProps={{
				header: t('Upgrade'),
				description: ''
			}}
			dynamicBaggagePricing={props.dynamicBaggagePricing}
			isLoading={props.isLoading}
			analyticsMeta={props.analyticsMeta}
			dataTestId="CarryOnBaggagePopup"
		/>
	);
};

export default UpgradeModal;
